module.exports = __webpack_public_path__ + "static/media/CaryssaNewbold.5501c3bc.jpg";